import { HeroConfig, HeroManifest } from './types';

export function resolveConfig(
  manifest: HeroManifest,
  partial: Partial<HeroConfig> | undefined,
): HeroConfig {
  const defaults = Object.fromEntries(manifest.fields.map((field) => [field.name, field.default]));
  return { ...defaults, ...(partial ?? {}) } as HeroConfig;
}

export function resolveBenefits(
  manifest: HeroManifest,
  config: HeroConfig,
): HeroConfig['benefits'] {
  const defaultField = manifest.fields.find((field) => field.name === 'benefits');
  const defaults = (defaultField?.default as HeroConfig['benefits']) ?? [];
  return Array.isArray(config.benefits) && config.benefits.length === defaults.length
    ? config.benefits
    : defaults;
}

export function resolveSearcherTabs(
  manifest: HeroManifest,
  config: HeroConfig,
): NonNullable<HeroConfig['searcherTabs']> {
  const defaultField = manifest.fields.find((field) => field.name === 'searcherTabs');
  const defaults = (defaultField?.default as HeroConfig['searcherTabs']) ?? [];
  return Array.isArray(config.searcherTabs) ? config.searcherTabs : defaults;
}
